export default __webpack_public_path__ + "static/media/fishbowlLogo.6a387f61.png";